import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import CheckBox from "../../../../../components/checkbox/CheckBox";
import Input from "../../../../../components/textbox/Input";
import Button from "../../../../../components/button/Button";
import stylesInfoCliniche from "../../InfoCliniche/InfoCliniche.module.css";
import Icon from "../../../../../components/icon/Icon";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili.json"

class Parte1C extends Component {

    state = {
        parte1C: {
            dataInizioTerapia: "",

            isoniazide: "",
            faseInizialeIsoniazide: "",
            continuazioneIsoniazide: "",

            rifampincina: "",
            faseInizialeRifampincina: "",
            continuazioneRifampincina: "",

            pirazinamide: "",
            faseInizialePirazinamide: "",
            continuazionePirazinamide: "",

            etambutolo: "",
            faseInizialeEtambutolo: "",
            continuazioneEtambutolo: "",

            altroTrattamento: "",
            altroValoreTrattamento: "",
            faseInizialeAltro: "",
            continuazioneAltro: "",

            trattamentiAggiuntivi: []
        },

        trattamentiAggiuntivi: []
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloDati = this.controlloDati.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.aggiungiTrattamento = this.aggiungiTrattamento.bind(this)
        this.aggiungiTrattamentoAStato = this.aggiungiTrattamentoAStato.bind(this)
        this.riceviValoreTrattamentoAggiuntivo = this.riceviValoreTrattamentoAggiuntivo.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {

        let parte1C = this.state.parte1C
        let parte1CCopia = this.props.segnalazioneCopia.esitoTbcPolmonare && this.props.segnalazioneCopia.esitoTbcPolmonare.parte1C ?
            this.props.segnalazioneCopia.esitoTbcPolmonare.parte1C : ""

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.esitoTbcPolmonare && parte1CCopia) {
            for (let key in parte1C) {
                if (parte1C.hasOwnProperty(key) === parte1CCopia.hasOwnProperty(key)) {
                    if (key === "dataInizioTerapia") {
                        parte1C[key] = Utils.transformDateForFrontend(parte1CCopia[key])
                    } else if (key === "trattamentiAggiuntivi") {
                        for (let i = 0; i < parte1CCopia[key].length; i++) {
                            this.aggiungiTrattamentoAStato()
                            parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo = parte1CCopia[key][i].altroTrattamentoAggiuntivo ?
                                parte1CCopia[key][i].altroTrattamentoAggiuntivo : ""
                            parte1C.trattamentiAggiuntivi[i].input = parte1CCopia[key][i].input ? parte1CCopia[key][i].input : ""
                            parte1C.trattamentiAggiuntivi[i].faseIniziale = parte1CCopia[key][i].faseIniziale ? parte1CCopia[key][i].faseIniziale : ""
                            parte1C.trattamentiAggiuntivi[i].continuazione = parte1CCopia[key][i].continuazione ? parte1CCopia[key][i].continuazione : ""
                        }
                    } else {
                        parte1C[key] = parte1CCopia[key]
                    }
                } else if (key === "trattamentiAggiuntivi") {
                    parte1C[key] = []
                } else {
                    parte1C[key] = ""
                }
            }
            this.setState({parte1C: parte1C})
        }
        this.aggiungiTrattamento()
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1C", oggettoBE, corretto)
    }

    validate() {
        if (this.state.parte1C.dataInizioTerapia && Utils.validateDate(this.state.parte1C.dataInizioTerapia, "Messages.DataInizio", "Messages.DataInizioOdierna")) {
            return Utils.validateDate(this.state.parte1C.dataInizioTerapia, "Messages.DataInizio", "Messages.DataInizioOdierna")
        }
        return ""
    }

    riceviValore(field, event) {
        let parte1C = this.state.parte1C
        parte1C[field] = event.target.value
        if (parte1C.isoniazide !== "true") {
            parte1C.isoniazide = parte1C.faseInizialeIsoniazide = parte1C.continuazioneIsoniazide = ""
        }
        if (parte1C.rifampincina !== "true") {
            parte1C.rifampincina = parte1C.faseInizialeRifampincina = parte1C.continuazioneRifampincina = ""
        }
        if (parte1C.pirazinamide !== "true") {
            parte1C.pirazinamide = parte1C.faseInizialePirazinamide = parte1C.continuazionePirazinamide = ""
        }
        if (parte1C.etambutolo !== "true") {
            parte1C.etambutolo = parte1C.continuazioneEtambutolo = parte1C.faseInizialeEtambutolo = ""
        }
        if (parte1C.altroTrattamento !== "true") {
            parte1C.altroTrattamento = parte1C.altroValoreTrattamento = parte1C.faseInizialeAltro = parte1C.continuazioneAltro = ""
        }
        this.setState({parte1C: parte1C})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1C", oggettoBE, corretto, this.validate())
    }

    controlloDati() {
        let parte1C = this.state.parte1C
        let corretto = []

        if(!parte1C.dataInizioTerapia || parte1C.dataInizioTerapia && Utils.isDateInValid(Utils.transformDateForBackend(parte1C.dataInizioTerapia), "-")) corretto[0] = "Campo \"Data di inizio della terapia\" mancante o errato";
        if (parte1C.isoniazide === "true" && ((parte1C.continuazioneIsoniazide === null || parte1C.continuazioneIsoniazide === "") ||
            (parte1C.faseInizialeIsoniazide === null || parte1C.faseInizialeIsoniazide === ""))) corretto[1] = "Campo \"Isoniazide\" mancante";
        if (parte1C.pirazinamide === "true" && ((parte1C.continuazionePirazinamide === null || parte1C.continuazionePirazinamide === "") ||
            (parte1C.faseInizialePirazinamide === null || parte1C.faseInizialePirazinamide === ""))) corretto[2] = "Campo \"Pirazinamide\" mancante";
        if (parte1C.etambutolo === "true" && ((parte1C.continuazioneEtambutolo === null || parte1C.continuazioneEtambutolo === "") ||
            (parte1C.faseInizialeEtambutolo === null || parte1C.faseInizialeEtambutolo === ""))) corretto[3] = "Campo \"Etambutolo\" mancante";
        if (parte1C.rifampincina === "true" && ((parte1C.continuazioneRifampincina === null || parte1C.continuazioneRifampincina === "") ||
            (parte1C.faseInizialeRifampincina === null || parte1C.faseInizialeRifampincina === ""))) corretto[4] = "Campo \"Rifampincina\" mancante";
        if (parte1C.altroTrattamento === "true" && ((parte1C.faseInizialeAltro === null || parte1C.faseInizialeAltro === "") ||
            (parte1C.continuazioneAltro === null || parte1C.continuazioneAltro === "") ||
            !parte1C.altroValoreTrattamento)) corretto[5] = "Campo \"Altro\" mancante";

        if (parte1C.trattamentiAggiuntivi.length > 0) {
            for (let i = 0; i < parte1C.trattamentiAggiuntivi.length; i++) {
                if (parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo === "true" &&
                    (!parte1C.trattamentiAggiuntivi[i].input ||
                        (parte1C.trattamentiAggiuntivi[i].faseIniziale === null || parte1C.trattamentiAggiuntivi[i].faseIniziale === "") ||
                        (parte1C.trattamentiAggiuntivi[i].continuazione === null || parte1C.trattamentiAggiuntivi[i].continuazione === ""))) {
                    corretto[5] = "Campo \"Altro\" mancante";
                }
            }
        }

        return corretto
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.parte1C))
        oggettoBE.dataInizioTerapia = Utils.transformDateForBackend(oggettoBE.dataInizioTerapia)
        let trattamentiAggiuntivi = JSON.parse(JSON.stringify(this.state.parte1C.trattamentiAggiuntivi))
        oggettoBE.trattamentiAggiuntivi = Utils.removeEmptyValueFromObject(trattamentiAggiuntivi)
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    aggiungiTrattamento() {
        const {t} = this.props
        let trattamentiAggiuntivi = []
        for (let i = 0; i < this.state.parte1C.trattamentiAggiuntivi.length; i++) {
            let trattamento = (
                <tr>
                    <td>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <CheckBox id={"altroTrattamentoAggiuntivo" + i}
                                          isRadio={false}
                                          checked={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo === "true"}
                                          fontColor={"black"}
                                          newCheckbox={true}
                                          text={t("SchedaSpecialeTbcPolmonare.altroTrattamento")}
                                          onChange={this.riceviValoreTrattamentoAggiuntivo}
                                />
                            </div>
                            <div className={"col-lg-3"}>
                                <Input
                                    id={"input" + i}
                                    required={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo === "true"}
                                    disabled={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo !== "true"}
                                    onChange={this.riceviValoreTrattamentoAggiuntivo}
                                    field={"input" + i}
                                    value={this.state.parte1C.trattamentiAggiuntivi[i].input}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.altroTrattamento")}
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <Input
                            type="number"
                            min="0"
                            required={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo === "true"}
                            disabled={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo !== "true"}
                            id={"faseIniziale" + i}
                            onChange={this.riceviValoreTrattamentoAggiuntivo}
                            field={"faseIniziale" + i}
                            value={this.state.parte1C.trattamentiAggiuntivi[i].faseIniziale}
                            placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                        />
                    </td>
                    <td>
                        <Input
                            type="number"
                            min="0"
                            required={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo === "true"}
                            disabled={this.state.parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo !== "true"}
                            id={"continuazione" + i}
                            onChange={this.riceviValoreTrattamentoAggiuntivo}
                            field={"continuazione" + i}
                            value={this.state.parte1C.trattamentiAggiuntivi[i].continuazione}
                            placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                        />
                    </td>
                </tr>
            )
            trattamentiAggiuntivi.splice(i, 0, trattamento)
        }

        return this.setState({trattamentiAggiuntivi: trattamentiAggiuntivi})

    }

    aggiungiTrattamentoAStato() {
        let parte1C = this.state.parte1C
        let newTrattamento = {
            altroTrattamentoAggiuntivo: "",
            input: "",
            faseIniziale: "",
            continuazione: ""
        }
        parte1C.trattamentiAggiuntivi.push(newTrattamento)
        this.setState({parte1C: parte1C})
    }

    riceviValoreTrattamentoAggiuntivo(field, event) {
        let parte1C = this.state.parte1C
        let length = parseInt(field.length)
        let indice = parseInt(field.substr((length - 1)));
        let nomeCampo = field.substr(0, (length - 1))
        parte1C.trattamentiAggiuntivi[indice][nomeCampo] = event.target.value
        for (let i = 0; i < parte1C.trattamentiAggiuntivi.length; i++) {
            if (parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo !== "true") {
                parte1C.trattamentiAggiuntivi[i].altroTrattamentoAggiuntivo = parte1C.trattamentiAggiuntivi[i].input =
                    parte1C.trattamentiAggiuntivi[i].faseIniziale = parte1C.trattamentiAggiuntivi[i].continuazione = ""
            }
        }
        this.setState({parte1C: parte1C})
        this.aggiungiTrattamento()
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1C", oggettoBE, corretto)
    }


    render() {

        const {t} = this.props

        const tabella = (
            <div style={{marginTop: "1rem"}}>
                <table style={{minWidth: "100%", border: " ridge   #f2f2f2", borderCollapse: "collapse"}}>
                    <tr style={{backgroundColor: "#e6e6e6"}}>
                        <th>
                            <p style={{fontWeight: "bold", marginLeft: "1rem"}}>
                                {t("SchedaSpecialeTbcPolmonare.trattamento1C")}<br/>
                                {t("SchedaSpecialeTbcPolmonare.trattamento1C2")}
                            </p>
                        </th>
                        <th>
                            <p style={{fontWeight: "bold", marginLeft: "1rem"}}>
                                {t("SchedaSpecialeTbcPolmonare.faseIniziale")}<br/>
                                {t("SchedaSpecialeTbcPolmonare.nmesi")}

                            </p>
                        </th>
                        <th>
                            <p style={{fontWeight: "bold", marginLeft: "1rem"}}>
                                {t("SchedaSpecialeTbcPolmonare.continuazione")}
                                <br/>
                                {t("SchedaSpecialeTbcPolmonare.nmesi")}
                            </p>
                        </th>
                    </tr>

                    <tr>
                        <td>
                            <CheckBox id={"isoniazide"}
                                      isRadio={false}
                                      checked={this.state.parte1C.isoniazide === "true"}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={t("SchedaSpecialeTbcPolmonare.isoniazide")}
                                      onChange={this.riceviValore}
                            />
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.isoniazide === "true"}
                                    disabled={this.state.parte1C.isoniazide !== "true"}
                                    id={"faseInizialeIsoniazide"}
                                    onChange={this.riceviValore}
                                    field={"faseInizialeIsoniazide"}
                                    value={this.state.parte1C.faseInizialeIsoniazide}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.isoniazide === "true"}
                                    disabled={this.state.parte1C.isoniazide !== "true"}
                                    id={"continuazioneIsoniazide"}
                                    onChange={this.riceviValore}
                                    field={"continuazioneIsoniazide"}
                                    value={this.state.parte1C.continuazioneIsoniazide}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <CheckBox id={"rifampincina"}
                                      isRadio={false}
                                      checked={this.state.parte1C.rifampincina === "true"}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={t("SchedaSpecialeTbcPolmonare.rifampincina")}
                                      onChange={this.riceviValore}
                            />
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input
                                        type="number"
                                        min="0"
                                        required={this.state.parte1C.rifampincina === "true"}
                                        disabled={this.state.parte1C.rifampincina !== "true"}
                                        id={"faseInizialeRifampincina"}
                                        onChange={this.riceviValore}
                                        field={"faseInizialeRifampincina"}
                                        value={this.state.parte1C.faseInizialeRifampincina}
                                        placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                    />
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.rifampincina === "true"}
                                    disabled={this.state.parte1C.rifampincina !== "true"}
                                    id={"continuazioneRifampincina"}
                                    onChange={this.riceviValore}
                                    field={"continuazioneRifampincina"}
                                    value={this.state.parte1C.continuazioneRifampincina}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <CheckBox id={"pirazinamide"}
                                      isRadio={false}
                                      checked={this.state.parte1C.pirazinamide === "true"}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={t("SchedaSpecialeTbcPolmonare.pirazinamide")}
                                      onChange={this.riceviValore}
                            />
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.pirazinamide === "true"}
                                    disabled={this.state.parte1C.pirazinamide !== "true"}
                                    id={"faseInizialePirazinamide"}
                                    onChange={this.riceviValore}
                                    field={"faseInizialePirazinamide"}
                                    value={this.state.parte1C.faseInizialePirazinamide}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.pirazinamide === "true"}
                                    disabled={this.state.parte1C.pirazinamide !== "true"}
                                    id={"continuazionePirazinamide"}
                                    onChange={this.riceviValore}
                                    field={"continuazionePirazinamide"}
                                    value={this.state.parte1C.continuazionePirazinamide}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <CheckBox id={"etambutolo"}
                                      isRadio={false}
                                      checked={this.state.parte1C.etambutolo === "true"}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={t("SchedaSpecialeTbcPolmonare.etambutolo")}
                                      onChange={this.riceviValore}
                            />
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.etambutolo === "true"}
                                    disabled={this.state.parte1C.etambutolo !== "true"}
                                    id={"faseInizialeEtambutolo"}
                                    onChange={this.riceviValore}
                                    field={"faseInizialeEtambutolo"}
                                    value={this.state.parte1C.faseInizialeEtambutolo}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.etambutolo === "true"}
                                    disabled={this.state.parte1C.etambutolo !== "true"}
                                    id={"continuazioneEtambutolo"}
                                    onChange={this.riceviValore}
                                    field={"continuazioneEtambutolo"}
                                    value={this.state.parte1C.continuazioneEtambutolo}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <div className={"row"}>
                                <div className={"col-lg-2"}>
                                    <CheckBox id={"altroTrattamento"}
                                              isRadio={false}
                                              checked={this.state.parte1C.altroTrattamento === "true"}
                                              fontColor={"black"}
                                              newCheckbox={true}
                                              text={t("SchedaSpecialeTbcPolmonare.altroTrattamento")}
                                              onChange={this.riceviValore}
                                    />
                                </div>
                                <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    <Input
                                        id={"altroValoreTrattamento"}
                                        required={this.state.parte1C.altroTrattamento === "true"}
                                        disabled={this.state.parte1C.altroTrattamento !== "true"}
                                        onChange={this.riceviValore}
                                        field={"altroValoreTrattamento"}
                                        value={this.state.parte1C.altroValoreTrattamento}
                                        placeholder={t("SchedaSpecialeTbcPolmonare.altroTrattamento")}
                                    />
                                </div>
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.altroTrattamento === "true"}
                                    disabled={this.state.parte1C.altroTrattamento !== "true"}
                                    id={"faseInizialeAltro"}
                                    onChange={this.riceviValore}
                                    field={"faseInizialeAltro"}
                                    value={this.state.parte1C.faseInizialeAltro}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                        <td>
                            <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <Input
                                    type="number"
                                    min="0"
                                    required={this.state.parte1C.altroTrattamento === "true"}
                                    disabled={this.state.parte1C.altroTrattamento !== "true"}
                                    id={"continuazioneAltro"}
                                    onChange={this.riceviValore}
                                    field={"continuazioneAltro"}
                                    value={this.state.parte1C.continuazioneAltro}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.nmesi")}
                                />
                            </div>
                        </td>
                    </tr>

                    {this.state.trattamentiAggiuntivi}

                </table>
            </div>
        )

        const data = (
            <div className={"row"}>
                <div className={"col-lg-7"}>
                    <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                        {t("SchedaSpecialeTbcPolmonare.dataInizioTerapia")}
                        <span className={styles.mandatoryColor}>*</span>
                        <span style={{
                            color: "black",
                            fontWeight: "normal"
                        }}>{t("SchedaSpecialeTbcPolmonare.dataInizioTerapia2")}</span>
                    </p>
                </div>
                <div className={"col-lg-4"}>
                    <Calendar id={"dataInizioTerapia"}
                              value={this.state.parte1C.dataInizioTerapia}
                              field={"dataInizioTerapia"}
                              onChange={this.riceviValore}
                              newCalendar={true}
                              errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                  t("SchedaSpecialeTbcPolmonare.dataInizioTerapia"))}
                              error={(!this.state.parte1C.dataInizioTerapia) ? false :
                                  Utils.isDateInValid(Utils.transformDateForBackend(this.state.parte1C.dataInizioTerapia), "-")}
                    />
                </div>

            </div>
        )

        const aggiungiTrattamento = (
            <Button
                onClick={() => {
                    this.aggiungiTrattamentoAStato();
                    this.aggiungiTrattamento()
                }}
                className={stylesInfoCliniche.testo + " " + stylesInfoCliniche.btnBluOutline}
                classes="btn mt-2 btnBluOutline mb-1 "
                style={{
                    textDecoration: "underline", padding: "5px", outline: "none", border: "none",
                    background: "none", float: "left", fontSize: "18px"
                }}
                text={t("SchedaSpecialeTbcPolmonare.aggiungiTrattamento")}
                icon={<Icon style={{fill: "#0073e6", width: "32px", height: "32px", paddingBottom: "10px"}}
                            id={"it-plus-circle"}/>}
            />
        )

        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeTbcPolmonare.parte1C")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    {data}
                    {tabella}
                    {aggiungiTrattamento}
                </div>
            </div>
        );
    }

}

export default withTranslation('common')(Parte1C)
